(function(){
  var g=document.getElementById('wp-gate'); if(!g){ document.body.classList.add('scrolled'); return; }
  var yes=g.querySelector('.yes'), no=g.querySelector('.no'), L=document.querySelectorAll('.cg-layer'), busy=false, finished=false;
  function unlock(){ document.documentElement.classList.remove('wp-locked'); document.body.classList.remove('wp-locked'); }
  function done(){ if(finished) return; finished=true; unlock(); g.classList.add('done'); for(var i=0;i<L.length;i++) L[i].classList.add('done'); document.body.classList.add('scrolled'); }
  var seen=false; try{ seen=sessionStorage.getItem('wp_on')==='1' || +localStorage.getItem('wp_on_until')>Date.now(); }catch(e){}
  if(/[?&]gate=1\b/.test(location.search)){ seen=false; document.documentElement.classList.remove('wp-on'); }
  if(seen){ done(); return; }
  document.documentElement.classList.add('wp-locked'); document.body.classList.add('wp-locked'); window.scrollTo(0,0);
  // Colour bloom: grow a transparent hole in the grey layer's mask, centred on the Yes button.
  function bloom(x,y){
    var W=innerWidth, H=innerHeight, R=Math.hypot(Math.max(x,W-x),Math.max(y,H-y))+4, t0=null, D=650;
    if(matchMedia('(prefers-reduced-motion: reduce)').matches){ done(); return; }
    function frame(t){ if(t0===null) t0=t; var p=Math.min(1,(t-t0)/D), e=p<.5?4*p*p*p:1-Math.pow(-2*p+2,3)/2, r=(e*R).toFixed(1);
      var m='radial-gradient(circle at '+x+'px '+y+'px, transparent '+r+'px, #000 '+(+r+2)+'px)';
      for(var i=0;i<L.length;i++){ L[i].style.webkitMaskImage=m; L[i].style.maskImage=m; }
      if(p<1) requestAnimationFrame(frame); else done(); }
    requestAnimationFrame(frame);
    setTimeout(done,D+600);
  }
  function enter(){
    if(busy) return; busy=true; try{ sessionStorage.setItem('wp_on','1'); localStorage.setItem('wp_on_until',String(Date.now()+30*864e5)); }catch(e){}
    try{ if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish) Shopify.analytics.publish('wp_age_gate_yes',{path:location.pathname}); }catch(e){}
    try{ if(window.ttq) ttq.track('ClickButton',{content_name:'age_gate_yes'}); }catch(e){}
    try{ if(window.gtag) gtag('event','age_gate_yes'); }catch(e){}
    var r=yes.getBoundingClientRect(); unlock(); g.classList.add('blooming'); bloom(Math.round(r.left+r.width/2),Math.round(r.top+r.height/2));
  }
  function leave(){ if(busy) return; busy=true; g.classList.add('off-air'); }
  yes.addEventListener('click',enter); no.addEventListener('click',leave);
})();
